'use client';

import {
	createListCollection, Card, Grid, GridItem, Button, SimpleGrid, Icon, Input,
	HStack,
} from '@chakra-ui/react';
import React from 'react';
import {
	MdOutlineBusinessCenter,
	MdOutlineLocationOn,
	MdOutlineFactory,
	MdOutlinePersonOutline,
	MdOutlineAccountBalanceWallet,
	MdOutlineSchool,
	MdTextFields,
} from 'react-icons/md';

import { educationOptions, salaryRangeOptions } from '@/modules/job/presentation/constants';
import {
	IconLabel,
	JobOccupationsSelectorDialog,
	JobLocationsSelectorDialog,
	JobIndustriesSelectorDialog,
} from '@/modules/shared';

import { Form } from '@packages/hook-form-wrapper';

export const JobSearch = () => {
	const currentSalaryCollection = createListCollection({ items: salaryRangeOptions });
	const educationCollection = createListCollection({ items: educationOptions });

	return (
		<Card.Root maxW="full">
			<Card.Body p={0}>
				<Grid
					columns={2}
					css={{
						'& > *': {
							_icon:             { mt: 2 },
							_odd:              { bg: 'gray.15' },
							borderBottom:      '1px solid',
							borderBottomColor: 'gray.15',
							p:                 6,
						},
					}}
					gap={0}
					gridTemplateColumns="200px 1fr"
				>
					<GridItem>
						<IconLabel icon={MdOutlineBusinessCenter} label="Occupation" variant="featured" />
					</GridItem>
					<GridItem>
						<JobOccupationsSelectorDialog>
							<Button size="md" variant="outline">Select Occupation</Button>
						</JobOccupationsSelectorDialog>
					</GridItem>
					<GridItem>
						<IconLabel icon={MdOutlineLocationOn} label="Job Location" variant="featured" />
					</GridItem>
					<GridItem>
						<JobLocationsSelectorDialog>
							<Button size="md" variant="outline">Select Location</Button>
						</JobLocationsSelectorDialog>
					</GridItem>
					<GridItem>
						<IconLabel icon={MdOutlineFactory} label="Job Industry" variant="featured" />
					</GridItem>
					<GridItem>
						<JobIndustriesSelectorDialog>
							<Button size="md" variant="outline">Select Industry</Button>
						</JobIndustriesSelectorDialog>
					</GridItem>
				</Grid>
				<SimpleGrid
					columns={1}
					css={{
						'& > *': {
							_icon:      { color: 'primary.100', h: 6, w: 6 },
							_notLast:   { borderBottom: '1px solid', borderBottomColor: 'gray.15' },
							alignItems: 'center',
							display:    'flex',
							flexDir:    'row',
							gap:        6,
							p:          6,
						},
					}}
					gap={0}
				>
					<GridItem alignItems="center" display="flex">
						<Icon as={MdOutlinePersonOutline} />
						<HStack alignItems="center" gap="xs" pt={1}>
							<Form.Checkbox name="fullTime" w="100px">Full Time</Form.Checkbox>
							<Form.Checkbox name="partTime" w="100px">Contract</Form.Checkbox>
							<Form.Checkbox name="contract" w="100px">Other</Form.Checkbox>
						</HStack>
					</GridItem>
					<GridItem>
						<Icon as={MdOutlineAccountBalanceWallet} />
						<Form.SelectInput
							collection={currentSalaryCollection}
							label="Current Salary"
							name="currentAnnualSalary"
							w="50%"
						/>
					</GridItem>
					<GridItem>
						<Icon as={MdOutlineSchool} />
						<Form.SelectInput
							collection={educationCollection}
							label="Current Education Level"
							name="currentEducationLevel"
							w="50%"
						/>
					</GridItem>
					<GridItem>
						<Icon as={MdTextFields} />
						<Input placeholder="Keyword" />
					</GridItem>
				</SimpleGrid>
			</Card.Body>
		</Card.Root>
	);
};
